import React from 'react';
import { FaArrowLeft, FaFilm, FaUserShield, FaShareAlt } from 'react-icons/fa';

const HeaderSection = ({ handleBack, selectedApp, handleShare }) => {
  const mode = String(selectedApp?.bookingType || 'FACE_TO_FACE').toUpperCase();
  const isVideo = mode === 'VIDEO_UPLOAD';

  return (
    <div className="d-flex align-items-center justify-content-between pb-3 mb-4 border-bottom border-secondary border-opacity-25 gap-2 gap-md-3">
      {/* 1. Far Left: Back Button */}
      <button 
        type="button" 
        className="btn btn-outline-light btn-sm px-2 px-md-3 py-1 fw-semibold d-inline-flex align-items-center gap-1 gap-md-2 rounded-2 flex-shrink-0"
        onClick={handleBack}
        style={{ background: 'rgba(255, 255, 255, 0.05)', border: '1px solid rgba(255, 255, 255, 0.15)', fontSize: '0.85rem' }}
        title="Back"
      >
        <FaArrowLeft size={12} />
        <span className="d-none d-sm-inline">Back</span>
      </button>

      {/* 2. Middle: Red Accent & Title/Metadata */}
      <div className="ps-2 ps-md-3 border-start border-danger border-3 flex-grow-1 min-w-0 mx-2">
        <h5 className="fw-bold text-white m-0 text-uppercase text-truncate" style={{ letterSpacing: '0.5px', fontSize: '0.95rem' }}>
          {isVideo ? "AI Audition Analysis & Match Report" : "Audition Booking & Meeting Details"}
        </h5>
        <div className="d-flex flex-wrap align-items-center gap-2 mt-1" style={{ fontSize: '0.8rem' }}>
          <span className="text-white-50 d-inline-flex align-items-center gap-1">
            <FaFilm size={11} className="text-danger" /> Project: <strong className="text-white text-truncate" style={{ maxWidth: '130px' }}>{selectedApp?.c_project_name || 'N/A'}</strong>
          </span>
          <span className="text-secondary opacity-50 d-none d-sm-inline">•</span>
          <span className="text-white-50 d-inline-flex align-items-center gap-1">
            <FaUserShield size={11} className="text-info" /> Role: <strong className="text-white text-truncate" style={{ maxWidth: '130px' }}>{selectedApp?.c_role_name || 'N/A'}</strong>
          </span>
        </div>
      </div>

      {/* 3. Far Right: Share Button */}
      {handleShare && (
        <button 
          type="button"
          onClick={handleShare}
          className="btn btn-outline-danger btn-sm px-2 px-md-3 py-1 fw-bold d-inline-flex align-items-center gap-1 gap-md-2 rounded-2 flex-shrink-0 ms-auto"
          style={{ borderRadius: '8px', border: '1px solid #dc3545', backgroundColor: 'transparent', fontSize: '0.85rem' }}
          title="Share Audition"
        >
          <FaShareAlt size={12} />
          <span className="d-none d-sm-inline">Share</span>
        </button>
      )}
    </div>
  );
};

export default HeaderSection;